import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { BaseApiService } from '../../../Services/base-api.service';
import { BaseComponent } from '../../../Base/base/base.component';
import { takeUntil, finalize } from 'rxjs';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.css'],standalone:false
})
export class AddUserComponent extends BaseComponent implements OnInit{
  userForm!: FormGroup;
  authService: any;
  router: any;
  errorMessage: any;
  imageUrl: string = '';
  loading:boolean=false;
  usernameAvailable: boolean = false;
  loadUsername:boolean=false
  notPresent:boolean=false;
  currentStep: number = 1;
  constructor
  (
     private messageService: MessageService,
     private formBuilder:FormBuilder,
     private api:BaseApiService
  )
  {
     super();
  }

  onSubmit() {
    if (this.userForm.valid) {
      this.loading=true;
      const formData = this.userForm.value;
      this.api.create("Auth/RegisterAdmin",formData)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe
      (
       {
         next: (response) =>
          {
            this.loading=false
            this.clearFormState();
            this.messageService.add({ severity: 'success', summary: 'Success', detail: response.message });
  
          },
          error:( error) => {
            this.loading=false
  
          }
       },
        
      );
    } else {
      this.userForm.markAllAsTouched();
    }
  }

  clearFormState() {
    localStorage.removeItem('userFormData');
    localStorage.removeItem('currentStep');
  }
  initilizaform(){
    this.userForm = this.formBuilder.group
    (
      {
           email      : ['', [Validators.required, Validators.email]],
           password   : ['', [Validators.required, Validators.minLength(6)]],
           username   : ['', Validators.required],
           supCategory: [''],
           subCategory: [''],
           userType:['',Validators.required],
           userRole:['',Validators.required]
      }
    );
  }

  isFirstStepValid(): boolean {

    const emailValid = this.userForm.get('email')?.valid;
    const passwordValid = this.userForm.get('password')?.valid;
    const usernameValid = this.userForm.get('username')?.valid;

    return !!emailValid && !!passwordValid && !!usernameValid;
  }

  loadFormState() {
    const savedFormData = localStorage.getItem('userFormData');
    const savedStep = localStorage.getItem('currentStep');
    if (savedFormData && savedStep) {
      this.userForm.setValue(JSON.parse(savedFormData));
      this.currentStep = +savedStep;
    }
  }

  saveFormState() {
    localStorage.setItem('userFormData', JSON.stringify(this.userForm.value));
    localStorage.setItem('currentStep', this.currentStep.toString());
  }

  issecond(): boolean {
    const emailValid    = this.userForm.get('supCategory')?.valid ?? false;
    const passwordValid = this.userForm.get('subCategory')?.valid ?? false;
    return emailValid && passwordValid;
  }



  checkUsernameAvailability() {
   this.loadUsername=true
   this.notPresent=false;
    const username = this.userForm.get('username')?.value;
     if (!username) {
      this.loadUsername=false
      return;
    }
    this.api.read(`Auth/GetByusername?username=${username}`)
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loadUsername=false
      })
    ).subscribe(
      {
        next:(response) => {
          if(response.message=='OK'){
            this.usernameAvailable = true;
            this.loadUsername=false
          }
          else
          {
            this.loadUsername=false
            this.notPresent = false;
            this.userForm.get('username')?.setValue('');

          }
           },
        error:(error) => {
          this.usernameAvailable = false;
          this.loadUsername=false
        }
      ,
      }

    );
  }

  nextStep() {
    if (this.currentStep <2) {
        this.currentStep++;
        this.saveFormState();
    }
  }

  previousStep() {
    if (this.currentStep > 1) {
        this.currentStep--;
        this.saveFormState();
    }
  }



  ngOnInit() {
    this.initilizaform();
  }
}
